<template>
  <v-container fluid>
    <BaseBreadcrumb
      :title="page.title"
      :icon="page.icon"
      :breadcrumbs="breadcrumbs"
    ></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12">
        <BaseCard heading="Blacklist">
          <listar-blacklist />
        </BaseCard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ListarBlacklist from '@/components/patio/ListarBlacklist'
export default {
  name: 'Blacklist',
  data() {
    return {
      page: {
        title: 'Gerenciamento de Blacklist',
      },
      breadcrumbs: [
        {
          text: 'Blacklist',
          disabled: false,
          to: '/patio/patio',
        },
        {
          text: 'Blacklist',
          disabled: false,
        },
      ],
    }
  },
  components: {
    ListarBlacklist,
  },
}
</script>

<style></style>
